(() => {
  const initMapLocationsGrid = () => {
    document
      .querySelectorAll("[data-arbaje-map-grid]")
      .forEach((section) => {
        if (section.dataset.initialized === "true") return;

        section.dataset.initialized = "true";

        const maps = section.querySelectorAll(
          "[data-arbaje-grid-map]"
        );

        maps.forEach((map) => {
          const coordinates =
            map.dataset.coordinates;

          const googleUrl =
            map.dataset.googleUrl;

          if (coordinates) {
            const embedUrl =
              "https://www.google.com/maps?q=" +
              encodeURIComponent(coordinates) +
              "&z=17&output=embed";

            map.src = embedUrl;
          }

          const mapLink =
            map
              .closest("[data-arbaje-location-card]")
              ?.querySelector(
                "[data-arbaje-grid-map-link]"
              );

          if (mapLink && googleUrl) {
            mapLink.href = googleUrl;
          }
        });
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initMapLocationsGrid
    );
  } else {
    initMapLocationsGrid();
  }

  document.addEventListener(
    "shopify:section:load",
    initMapLocationsGrid
  );
})();